(function() {
    "use strict";

    angular
    .module("app.layout")
    .directive("toolkit", toolkit);

    /* @ngInject */
    function toolkit($location) {
        var directive = {
            bindToController: true,
            templateUrl: "toolkit.tpl",
            controller: toolkitController,
            controllerAs: "vm",
            link: link,
            restrict: "E",
            scope: {
                data: "="
            }
        };

        return directive;

        function link(scope, element, attrs) {
            if (
                !angular.isArray(scope.vm.data.query) &&
                scope.vm.data.query.length === 0
            ) {
                return null;
            }

            // parse resources data from query and prepare tabs content
            var resources = scope.vm.data.query[0].customs.toolbox;
            var eCards = scope.vm.data.query[0].customs.e_cards;
            var tabs = {};

            angular.forEach(resources, function(r) {
                var i = {
                    type: r.type,
                    title: r.name
                };

                switch (r.type) {
                    case "image":
                        if (!r.data.media.value) {
                            i.imgSrc = '';
                            i.imgAlt = '';
                            i.downloadSrc = '';
                        } else {
                            i.imgSrc = r.data.media.value.sizes.full.url;
                            i.imgAlt = r.data.media.value.alt;
                            i.downloadSrc = r.data.media.value.sizes.full.url;
                        }
                        i.excerpt = r.data.excerpt.value;
                    break;
                    case "video":
                        i.videoSrc = r.data.video.value;
                        i.excerpt = r.data.excerpt.value;
                    break;
                    case "document":
                        if (!r.data.media.value) {
                            i.downloadSrc = '';
                        } else {
                            i.downloadSrc = r.data.media.value.url;
                        }
                        i.excerpt = r.data.excerpt.value;
                    break;
                    case "article":
                        i.excerpt = r.data.excerpt.value;
                        i.post = r.data.post.value;

                        if (
                            typeof r.data.media === 'object' &&
                            typeof r.data.media.value === 'object'
                        ) {
                            if (!r.data.media.value) {
                                return false;
                            }
                            i.hasImage = true;
                            i.imgSrc = r.data.media.value.sizes.full.url;
                            i.imgAlt = r.data.media.value.alt;
                        } else {
                            i.hasImage = false;
                        }
                    break;
                    default:
                        i.type = 'unsupported';
                }

                var catKey = r.cat.slug || 'other-resources';
                if (tabs[catKey] === undefined) {
                    tabs[catKey] = {
                        key: catKey,
                        label: r.cat.name,
                        groups: {}
                    };
                }

                var groupKey = r.group.slug || "other";
                if (tabs[catKey].groups[groupKey] === undefined) {
                    tabs[catKey].groups[groupKey] = {
                        key: groupKey,
                        label: r.group.name || "",
                        items: []
                    };
                }
                tabs[catKey].groups[groupKey].items.push(i);
            });

            // append E-Cards to tabs
            tabs['e-cards'] = {
                key: 'e-cards',
                label: 'E-Cards',
                groups: {
                    "other": {
                        key: "other",
                        label: "",
                        items: [
                            {
                                type: "form",
                                formId: eCards.form_id,
                                fields: eCards.form_fields,
                                settings: eCards.form_settings
                            }
                        ]
                    }
                }
            };


            // sort items by names within group

            // + ---  sorting for dummies :)))

            scope.vm.tabs = {};

            var order = [ 'e-cards','printed-materials', 'social-media', 'other-resources'];
            for (var i in order) {
                scope.vm.tabs[order[i]] = tabs[order[i]];
            }

            // - ---

            //scope.vm.tabs = tabs;

            var searchObject = $location.search();

            scope.selectTab = function(tabKey) {
                scope.vm.activeTab = scope.vm.tabs[tabKey];
            };

            if (scope.vm.tabs[searchObject.innerTab]) {
                scope.selectTab(searchObject.innerTab);
            } else {
                scope.selectTab('e-cards');
                // scope.selectTab('printed-materials');
            }
            // scope.quillFix();
        } // link
    }

    /* @ngInject */
    function toolkitController($scope, $sce, $location, $document) {
        // parses video id's from links like:
        // https://youtu.be/XYZ
        // https://www.youtube.com/embed/XYZ?start=60
        function getVideoId(item) {
            if (
                typeof item !== 'object' ||
                !angular.isString(item.videoSrc) ||
                item.videoSrc.trim() === ''
            ) { return null; }

            var s = item.videoSrc;
            var lastSlashIdx = s.lastIndexOf('/');
            var queryIdx = s.indexOf('?');

            if (lastSlashIdx === -1) { return item.videoSrc; }

            if (queryIdx === -1) {
                return s.substring(lastSlashIdx + 1);
            }

            var res = s.substring(lastSlashIdx + 1, queryIdx);
            return res;
        }

        $scope.getVideoSrc = function(item) {
            var embedUrl = "https://www.youtube.com/embed/";
            var videoId = getVideoId(item);
            if (videoId === null) { return '#'; }

            return $sce.trustAsResourceUrl(embedUrl + videoId + "?controls=0&loop=1");
        };

        $scope.getYouTubeLink = function(item) {
            var watchUrl = "https://www.youtube.com/watch?v=";
            var videoId = getVideoId(item);
            if (videoId === null) { return '#'; }

            return watchUrl + videoId;
        };

        $scope.getDownloadUrl = function(item) {
            if (
                typeof item !== "object" ||
                !angular.isString(item.downloadSrc) ||
                item.downloadSrc.trim() === ''
            ) { return '#'; }

            var res = $location.protocol() + "://" + $location.host() + item.downloadSrc;

            return res;
        };

        $scope.getDownloadFileName = function(item) {
            var a = item.imgAlt;
            var s = item.downloadSrc;

            if (!angular.isString(s) || s.trim() === '') { return ''; }

            var ext = s.substring(s.lastIndexOf('.'));
            var res;
            if (!angular.isString(a) || a.trim() === '') {
                res = s.substring(s.lastIndexOf("/") + 1);
            } else {
                res = a.replace(/\s/g, "_") + ext;
            }

            return res;
        };


        $scope.copyLinkToClipboard = function(event) {
            event.preventDefault();
            event.stopPropagation();

            var link = event.currentTarget.getAttribute("href");

            var $tempInp = $("<input>");
            $("body").append($tempInp);
            $tempInp.val(link).select();
            document.execCommand("copy");
            $tempInp.remove();

            toastr.success("Link copied to clipboard");
        };

        // on broadcasted e-cards design change event paste the message to 'your message' textarea
        $scope.$on('pieRadioDesignChangeEvent', function(event, args) {
            if($scope.vm.activeTab.key === 'e-cards' && args.name === 'e-card-design') {
                var delta = window.quills[0].clipboard.convert(args.value.text);
                window.quills[0].setContents(delta);
            }
        });
    }
})();
